import React from 'react';
import { ShowcaseItem as ShowcaseItemType } from '../../../types';
import ShowcaseItem from './ShowcaseItem';

interface ShowcaseGridProps {
  items: ShowcaseItemType[];
  layoutType: 'grid' | 'canvas';
  isOwnProfile: boolean;
}

const ShowcaseGrid: React.FC<ShowcaseGridProps> = ({ items, layoutType, isOwnProfile }) => {
  // Sort items by order to ensure consistent stacking
  const sortedItems = [...items].sort((a, b) => (a.order || 0) - (b.order || 0));

  // Determine the number of rows needed for the grid layout
  const maxRow = Math.max(...items.map(item => item.y + item.h), 0);

  if (layoutType === 'canvas') {
    const maxHeight = Math.max(...items.map(item => item.y + item.h), 500);
    return (
      <div 
        className="relative bg-white dark:bg-gray-900 rounded-3xl p-4 md:p-6 shadow-sm border border-gray-100 dark:border-gray-800 overflow-hidden"
        style={{ minHeight: `${maxHeight + 48}px` }} // +48 for padding
      >
        {sortedItems.map((item) => (
          <ShowcaseItem 
            key={item.id} 
            item={item} 
            isOwnProfile={isOwnProfile}
            layoutType="canvas"
          />
        ))}
      </div>
    );
  }

  return (
    <div 
      className="grid grid-cols-12 gap-2 md:gap-4 bg-white dark:bg-gray-900 rounded-3xl p-4 md:p-6 shadow-sm border border-gray-100 dark:border-gray-800 min-h-[400px]"
      style={{ 
        gridTemplateRows: `repeat(${maxRow}, auto)`,
      }}
    >
      {sortedItems.map((item) => (
        <ShowcaseItem 
          key={item.id} 
          item={item} 
          isOwnProfile={isOwnProfile}
          layoutType="grid"
        />
      ))}
    </div>
  );
};

export default ShowcaseGrid;
